import './index.css';
import View from '../view';
import Text from '../text';
import React from 'react';
interface Props {
  buttonStyle?: any;
  buttonClassName?: any;
  labelStyle?: any;
  labelClassName?: any;
  onPress?: any;
  children?: any;
  disabled?: boolean;
}
const Button = ({
  onPress,
  buttonClassName,
  buttonStyle,
  labelStyle,
  labelClassName,
  children = '',
  disabled = false
}: Props) => {
  if (disabled) {
    buttonClassName = `${buttonClassName} disable-button`;
  }
  return (
    <View onPress={onPress} style={buttonStyle} className={`button-container ${buttonClassName}`}>
      {children && (
        <Text style={labelStyle} className={`button-label ${labelClassName}`}>
          {children}
        </Text>
      )}
    </View>
  );
};
Button.defaultProps = {
  onPress: () => {},
  buttonClassName: '',
  buttonStyle: {},
  labelStyle: {},
  labelClassName: '',
  disabled: false
};
export default React.memo(Button);
